module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="soft-review-info soft-review-summary">\n    <header>\n        ' +
((__t = ( $.svgIcon('warning') )) == null ? '' : __t) +
'\n        <h2>' +
__e( count ) +
' potential issues found</h2>\n        <div>Please review to finish applying</div>\n    </header>\n    <footer>\n        <button class="btn btn-primary btn-large">Review</button>\n    </footer>\n</div>\n';

}
return __p
}